<template>
    <div id="pay">
        <div>
            <el-card>
                <el-form ref="form" :model="form" label-width="80px" :inline="true" size="small">
                    <el-form-item>
                        <el-button type="primary" size="small" @click="addWeixinPay">添加Paypal</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="tableData" border style="width: 100%">
                    <el-table-column prop="appname" label="应用标识">
                    </el-table-column>
                    <el-table-column prop="clientId" label="Client-ID">
                    </el-table-column>
                    <el-table-column prop="appSecret" label="App-Secret">
                    </el-table-column>
                    <el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                            <el-button type="warning" plain size="small" @click="editWeixinPay(scope.row)">
                                修改
                            </el-button>
                            <el-button type="danger" plain size="small" @click="removeWeixinPay(scope.row.appname)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-card>
            <el-card>
                <el-row :gutter="20">
                    <el-col :span="this.$store.state.elColNum">
                        <el-form ref="form" :model="form" :label-width="this.$store.state.setLabelWidth" size="small">
                            <el-divider content-position="left">微信支付设置</el-divider>
                            <el-form-item label="微信开放平台AppID">
                                <el-input v-model="form.appid"></el-input>
                            </el-form-item>
                            <el-form-item label="微信开放平台AppSecret">
                                <el-input v-model="form.appSecret"></el-input>
                            </el-form-item>
                            <el-form-item label="微信公众平台AppId">
                                <el-input v-model="form.wechat_official_appid"></el-input>
                            </el-form-item>
                            <el-form-item label="微信公众平台AppSecret">
                                <el-input v-model="form.wechat_official_appsecret"></el-input>
                            </el-form-item>
                            <el-form-item label="微信商户号">
                                <el-input v-model="form.mchid"></el-input>
                            </el-form-item>
                            <el-form-item label="微信密钥key">
                                <el-input v-model="form.mchkey"></el-input>
                            </el-form-item>
                            <el-form-item label="是否开启">
                                <el-switch v-model="form.wxpay_switch" active-value="1" inactive-value="0">
                                </el-switch>
                            </el-form-item>
                            <el-divider content-position="left">支付宝支付设置</el-divider>
                            <el-form-item label="支付宝AppID">
                                <el-input v-model="form.aliapp_appid"></el-input>
                            </el-form-item>
                            <el-form-item label="支付宝合作者身份ID">
                                <el-input v-model="form.aliapp_partner"></el-input>
                            </el-form-item>
                            <el-form-item label="支付宝登录账号">
                                <el-input v-model="form.aliapp_seller_id"></el-input>
                            </el-form-item>
                            <el-form-item label="支付宝公钥">
                                <el-input v-model="form.alipayrsaPublicKey" type="textarea"
                                    :autosize="{  maxRows: 6}"></el-input>
                            </el-form-item>
                            <el-form-item label="支付宝安卓密钥">
                                <el-input v-model="form.aliapp_key_android" type="textarea"
                                    :autosize="{  maxRows:6}"></el-input>
                            </el-form-item>
                            <el-form-item label="支付宝苹果密钥">
                                <el-input v-model="form.aliapp_key_ios" type="textarea"
                                    :autosize="{ maxRows: 6}"></el-input>
                            </el-form-item>
                            <el-form-item label="是否开启">
                                <el-switch v-model="form.alipay_switch" active-value="1" inactive-value="0">
                                </el-switch>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onSubmit">保存</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </el-card>
            <!--            新增或编辑-->
            <el-dialog :title="editTitle" :width="this.$store.state.dialogWidth" :visible.sync="visible">
                <el-row :gutter="20">
                    <el-col :span="this.$store.state.elColNum">
                        <el-form ref="form" :label-width="this.$store.state.labelWidth" size="small">
                            <el-form-item label="应用标识">
                                <el-input v-model="edit.appname" placeholder="必需唯一 (英文+数字),与终端参数一至"
                                    maxlength="14"></el-input>
                            </el-form-item>
                            <el-form-item label="Client-ID">
                                <el-input v-model="edit.clientId"></el-input>
                            </el-form-item>
                            <el-form-item label="App-Secret">
                                <el-input v-model="edit.appSecret"></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="visible=false" size="small">取 消</el-button>
                    <el-button type="primary" @click="dialogAffirm" size="small">确 定</el-button></span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    export default {
        name: "pay",
        data() {
            return {
                form: {
                    appid: '',
                    appSecret: '',
                    mchid: '',
                    mchkey: '',
                    wechat_official_appid: '',
                    wechat_official_appsecret: '',
                    wxpay_switch: '0',
                    alipay_switch: '0',
                    aliapp_partner: '',
                    aliapp_seller_id: '',
                    aliapp_key_android: '',
                    aliapp_key_ios: '',
                    alipayrsaPublicKey: '',
                    aliapp_appid: '',
                },
                tableData: [],
                edit: {},
                visible: false,
                editAppname: '',
                editTitle: ''
            }
        },
        created() {
            this.getData()
        },
        methods: {
            getData() {
                this.$axios.post('admin/config/pay', '').then((res) => {
                    this.form = res.data;
                });
                this.$axios.post('admin/config/extend_pay', {
                    platform: 'pal'
                }).then((res) => {
                    this.tableData = res.data;
                });
            },
            onSubmit() {
                this.$axios.post('admin/config/pay_set', {
                    config: this.form
                }).then((res) => {
                    this.$message.success('成功');
                    this.getData();
                    this.visible = false
                });
            },
            addWeixinPay() {
                this.edit = {
                    appname: '',
                    clientId: '',
                    appSecret: ''
                };
                this.editAppname = '';
                this.editTitle = '新增Paypal';
                this.visible = true;
            },
            editWeixinPay(scope) {
                this.edit = JSON.parse(JSON.stringify(scope));
                this.editAppname = scope.appname;
                this.editTitle = '编辑Paypal';
                this.visible = true;
            },
            dialogAffirm() {
                // 添加
                this.$axios.post('admin/config/extend_pay_set', {
                    config: this.edit,
                    platform: 'pal',
                    appname: this.editAppname
                }).then((res) => {
                    this.$message.success('成功');
                    this.getData();
                    this.visible = false
                });
            },
            removeWeixinPay(appname) {
                this.$confirm('确定要删除该Paypal操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.post('admin/config/extend_pay_del', {
                        appname,
                        platform: 'pal'
                    }).then((res) => {
                        this.$message.success('删除成功!');
                        this.getData();
                    });
                }).catch(() => {

                });
            }
        }
    }
</script>

<style scoped>

</style>